import {
	set,
	throwOnEmptyPath,
	// unset,
	withPath
} from '@mapsight/core/lib/base/actions';
// import {batchActions} from 'redux-batched-actions';
import {FEATURE_LIST} from '@mapsight/ui/src/js/config/constants/controllers';

// TODO move to @mapsight/ui
export function setListVisible(value) {
	return set([FEATURE_LIST, 'visible'], value);
}


// TODO move to @mapsight/ui
export function setListFeatureSource(featureSource) {
	return set([FEATURE_LIST, 'featureSource'], featureSource);
}

// for internal use by route-to-store
export const ACTION_SET_FROM_ROUTE = 'MAPSIGHT_SET_FROM_ROUTE';

export function setFromRoute(path, value) {
	throwOnEmptyPath(path);

	return withPath({
		type: ACTION_SET_FROM_ROUTE,
		value: value,
	}, path);
}

export function selectExclusivelyFromRoute(controllerName, selectionId, featureId) {
	return setFromRoute(
		[controllerName, selectionId, 'features'],
		Array.isArray(featureId) ? featureId : [featureId]
	);
}

export function deselectAllFromRoute(controllerName, selectionId) {
	return selectExclusivelyFromRoute(controllerName, selectionId, []);
}

// This is only to hide action from mapsight automatically switching the view TODO: Fix it there.
// TODO 2022-01-11 ACTION_SET_VIA_HISTORY is unused by now and only kept as reference in the navpos-selection-controller
export const ACTION_SET_VIA_HISTORY = 'SET_VIA_HISTORY';
// export function selectExclusivelyViaHistory(controllerName, selectionId, featureId) {
// 	return setFromRoute(
// 		[controllerName, selectionId, 'features'],
// 		Array.isArray(featureId) ? featureId : [featureId]
// 	);
// }
//
// export function deselectAllViaHistory(controllerName, selectionId) {
// 	return selectExclusivelyViaHistory(controllerName, selectionId, []);
// }
